<template>
  <div class="ncrm-mailjet-auto-sync">
    <v-switch
      :model-value="autoSyncEnabled"
      color="primary"
      density="compact"
      hide-details
      inset
      :loading="saving"
      :disabled="saving"
      :label="$t('ncrm.integrations.mailjet.panel.autoSync.label')"
      @update:model-value="updateAutoSync"
    />
    <span class="text-caption text-medium-emphasis">
      {{ $t("ncrm.integrations.mailjet.panel.autoSync.schedule") }}
    </span>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "NcrmMailjetAutoSyncControl",
  props: {
    account: { type: Object, required: true },
  },
  emits: ["account-updated", "notify"],
  data() {
    return {
      saving: false,
    };
  },
  computed: {
    accountId() {
      return this.account?.id || null;
    },
    autoSyncEnabled() {
      return this.account?.auto_sync_enabled === undefined
        ? true
        : Number(this.account.auto_sync_enabled) === 1;
    },
  },
  methods: {
    extractError(error, fallbackKey) {
      return error?.response?.data?.error || error?.message || this.$t(fallbackKey);
    },
    async updateAutoSync(enabled) {
      if (!this.accountId) return;
      this.saving = true;
      try {
        const { data } = await axios.patch(
          `/ncrm/integrations/mailjet/accounts/${this.accountId}`,
          { autoSyncEnabled: !!enabled }
        );
        if (data?.account) this.$emit("account-updated", data.account);
        this.$emit("notify", {
          color: "success",
          message: enabled
            ? this.$t("ncrm.integrations.mailjet.panel.autoSync.enabled")
            : this.$t("ncrm.integrations.mailjet.panel.autoSync.disabled"),
        });
      } catch (error) {
        this.$emit("notify", {
          color: "error",
          message: this.extractError(error, "ncrm.integrations.mailjet.panel.errors.autoSync"),
        });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.ncrm-mailjet-auto-sync {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 6px;
}
@media (max-width: 720px) {
  .ncrm-mailjet-auto-sync {
    width: 100%;
  }
}
</style>
